<template>
  <section class="rule" v-once>
    <div class="rule-body">
      <div class="content">
        <h1>后期制作服务规则及声明</h1>
        <ol>
          <li>
            <p>
              订单制作时间：用户下单至首次交货时间不超过72小时；具体时间以服务详情页描述为准。
            </p>
          </li>
          <li>
            <p>
              服务规格为一首常规单曲：除片段修音和合唱歌曲外，一次服务仅提供与作品对应的单人单次录音的制作，时长不超过5分钟，超出的时长不计入常规服务范围内，每超出一分钟，按照购买服务的20%补交差价。
            </p>
          </li>
          <li>
            <p>
              加急订单：如用户需要加急服务，则需额外支付加急服务费。加急服务费不享受优惠折扣。不同服务的加急费用不同，以下单页显示的金额为准。加急服务从下单到首次提交服务成品将在4小时内完成，加急时效以下单页显示为准；首次提交服务成品未在4小时内完成的，将全额退款。加急服务的4小时期限仅限首次交货；如需返工，则遵循平台统一返工修改的时间，返工期限不超过3个自然日。
            </p>
          </li>
          <li>
            <p>
              订单升级：首次提交服务成品前，用户可申请升级当前服务，成功支付服务差价后，制作师将按照升级后的标准提供服务。不支持服务降级申请。
            </p>
          </li>
          <li>
            <p>
              免费返工：在提交成品7日内，提供免费修改返工机会，不同服务的返工次数不同，请参照服务详情页。
            </p>
          </li>
          <li>
            <p>
              除免费返工次数外，需要增加返工次数的，按50元/次标准进行收费，每次返工期限不超过3个自然日。
            </p>
          </li>
          <li>
            <p>
              成品验收：平台有权在成品试听中添加水印，待确认验收或订单自动完结，将提供用户无水印的完整成品。添加水印并不代表本服务由平台方提供，本服务由第三方提供。
            </p>
          </li>
          <li>
            <p>
              经制作师判断，若下单素材不符合后期制作标准，系统将关闭订单，并进行全额退款。
            </p>
          </li>
          <li>
            <p>
              片段修音：一次服务仅提供与作品对应的单人单次录音的制作，时长不超过60秒，从人声开始截取60秒片段淡出结束。
            </p>
          </li>
          <li>
            <p>
              付款成功3分钟以内，用户可无理由直接取消订单，订单将全额退款。超过3分钟，不支持全额退款。
            </p>
          </li>
          <li>
            <p>
              <strong>
                订单退款标准（定金服务及其他特殊活动除外）：<br>
                因本服务的特殊性，订单开始制作即代表制作师已付出时间、人力成本，如用户申请退款即视为用户同意按照以下规则执行：<br>
                （1）付款成功超过3分钟，即默认已开始制作，若用户申请退款，按照支付金额的50%退款。<br>
                （2）订单完成，用户即可收到无水印的服务成品，无特殊情况，不支持任何理由的退款申请。<br>
                退款成功的订单不支持对制作后的作品进行发布及下载。
              </strong>
            </p>
          </li>
          <li>
            <p>
              退款申请将在3个工作日内确认。退款申请被确认后，将按原支付路径进行退款。因支付宝、微信等是利用第三方软件实现的提现、转账等操作，所以退款并非能够即时到账，系统自动退回支付账户一般需花费1-3个工作日。
            </p>
          </li>
          <li>
            <p>
              用户下单即代表授权调取平台上的歌曲（包括私密歌曲）以供修音师、混音师制作。
            </p>
          </li>
          <li>
            <p>
              用户完成支付视为用户同意本规则，平台有权根据实际业务发展适时的修改本规则。用户可以通过平台官网随时查阅相关内容。本规则变更后，如果用户继续购买相关服务，即视为用户已接受修改后的规则。请用户务必在接受本规则项下所述的服务前,仔细阅读本规则,并明确理解其中重点加粗加黑部分。
            </p>
          </li>
        </ol>
      </div>

      <div class="action">
        <a href="" @click.prevent="ok">确认</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MallRule',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ok() {
      this.$emit('update:show', false);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_css/helper.scss";

.rule {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);

  .rule-body {
    position: absolute;
    top: 46%;
    left: 50%;
    width: 335px;
    background: #fff;
    border-radius: 6px;
    @extend %center-xy;
  }

  .action {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    border-top: 1px solid #eee;

    a {
      display: block;
      width: 100%;
      color: #ff5046;
      font-size: .426667rem;
      line-height: 45px;
      text-align: center;
    }
  }

  .content {
    max-height: 450px;
    padding-right: 15px;
    padding-bottom: 15px;
    padding-left: 15px;
    overflow: auto;

    h1 {
      color: #121212;
      font-weight: bolder;
      font-size: 18px;
      text-align: center;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
    }

    ol {
      margin-top: 20px;
      margin-left: 10px;

      li {
        margin-top: 10px;
        margin-left: 10px;
        font-size: 14px;
        list-style-position: outside;
        list-style-type: decimal;
      }
    }

    .table {
      width: 100%;
      font-size: 12px;
      table-layout: fixed;
      background-color: #ccc;
      border-collapse: separate;
      border-spacing: 1px;

      td,
      th {
        padding: 5px;
        background-color: #fff;
      }
    }
  }
}
</style>
